module.exports = __webpack_public_path__ + "static/41-wannacry-may2017-91f3df8a89fae3eac703c892bf00c1be.jpg";